const SpecText = ({ className = "text-main-color", children }) => {
  return <span className={className}>{children}</span>;
};

export default SpecText;
